import { CheckIcon } from '@chakra-ui/icons'
import { MdPeople as PeopleIcon } from 'react-icons/md'
import cx from 'classnames'
import Icon from 'components/Icon'
import { IGroup } from 'interfaces/group'
import styles from '../../shareWithGroupDialog.module.scss'

interface IGroupOptionProps {
  group: IGroup
  isSelected?: boolean
  toggleGroup: (id: number) => void
  setDeleteGroupId: (id: number) => void
}

const GroupOption = (props: IGroupOptionProps) => {
  const { toggleGroup, setDeleteGroupId, group, isSelected } = props

  return (
    <div className={cx(styles.itemWrapper, { [styles.selectedItem]: isSelected })}>
      <div
        className={styles.nameWrapper}
        onClick={() => {
          toggleGroup(Number(group.id))
        }}
      >
        <div className={styles.iconWrapper}>
          <PeopleIcon />
        </div>{' '}
        <span>{group.name}</span>
        {isSelected && <CheckIcon className={styles.checkIcon} />}{' '}
      </div>
      <Icon
        icon="trash-alt"
        group="fontawesome"
        onClick={() => {
          setDeleteGroupId(group.id ?? 0)
        }}
      />
    </div>
  )
}

export default GroupOption
